import React from "react"
import {TaskCard} from "../TaskCard/TaskCard"
import {TaskCardItem} from "../TaskCard/types"

interface TaskCardListProps {
	tasks: TaskCardItem[]
}

export function TaskCardList({tasks}: TaskCardListProps) {
	return (
		<div className="task-card-list">
			{tasks.map((task, index) => (
				<TaskCard
					key={index}
					title={task.title}
					description={task.description}
					duration={task.duration}
					icon={task.icon}
					state={task.isDone ? "done" : "default"}
					onClick={() => {
						if (task.url) {
							window.open(task.url, "_blank", "noopener")
						} else {
							task.onClick?.()
						}
					}}
				/>
			))}
		</div>
	)
}
